export default __webpack_public_path__ + "media/images/features/ambassador/profiles/yossie_san-c525f2167193e6beda2cbcb1f43fc81a.jpg";